import { cvAnalysisResponseSchema } from './cv-analysis';

import type { CVAnalysisResponse } from './cv-analysis.factories';
import type { ValidatingHttpFetcherWithBaseUrl } from '../../../shared/source/validating-http-fetcher';
import type Result from 'true-myth/result';

export type FetchCvAnalysis = (userId: string) => Promise<Result<CVAnalysisResponse, unknown>>;

export const createFetchCvAnalysis = (dependencies: {
    readonly validatingCobrainerApiFetcher: ValidatingHttpFetcherWithBaseUrl;
}): FetchCvAnalysis => {
    const { validatingCobrainerApiFetcher } = dependencies;

    return (userId: string) => {
        return validatingCobrainerApiFetcher.get(cvAnalysisResponseSchema, {
            pathname: `/cv-analysis/${userId}`,
        });
    };
};
